import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuItemService {
  constructor(private data: DataService) {}

  add(payload: any, message?: string): Observable<any> {
    return this.data.post('menu-item', payload, message);
  }

  getAll(): Observable<any> {
    return this.data.get('menu-item/list');
  }

  getEditable(): Observable<any> {
    return this.data.get('menu-item/list-edit');
  }

  updateOrder(payload: any): Observable<any> {
    return this.data.post('menu-item/order', payload);
  }

  delete(id: number, message?: string): Observable<boolean> {
    return this.data.delete(`menu-item/list?id=${id}`, message);
  }
}
